var cibPatreon = ["32 32", "<path d='M20.516 0.697c-6.355 0-11.521 5.167-11.521 11.521 0 6.333 5.167 11.484 11.521 11.484 6.333 0 11.484-5.151 11.484-11.484 0-6.355-5.151-11.521-11.484-11.521zM0.005 31.38h5.625v-30.683h-5.625z'/>"];

export { cibPatreon };

